import applePay from 'braintree-web/apple-pay';
import { ActionStatus } from '../../../../common/constants/action-status';
import { StoreState } from '../../../../store/store.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createClient, getBraintreeClient } from '../../braintree';
import { waitForBraintreeClient } from '../../../../store/store';

/**
 * Creates braintree Apple Pay instance only once.
 */
export const createApplePayInstance = createAsyncThunk(
  'braintree/createApplePayInstance',
  async (_data: any, thunkAPI) => {
    try {
      await thunkAPI.dispatch(createClient(_data));
      await waitForBraintreeClient();

      const configuration: any = {
        client: getBraintreeClient(thunkAPI.getState() as StoreState)
      };

      return await applePay.create(configuration);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_arg, {getState}) => {
      const state = getState() as StoreState;
      if (
        state.braintreeState.applePayInstance.status === ActionStatus.loading ||
        state.braintreeState.applePayInstance.status === ActionStatus.succeeded
      ) {
        return false;
      }
      return true;
    },
  }
);
